<template>
  <div class="homepage-container">
    <!-- 页面标题区域 -->
    <el-card class="homepage-title-card">
      <h1 class="homepage-title">首页</h1>
      <p class="homepage-description">
        雪音收藏馆，提供主要网页跳转功能、皮套信息收录及图片下载功能、歌单检索功能、礼物积分兑换计算器及分值兑换一览表。
      </p>
    </el-card>

    <!-- 新增：直播时间简介板块 -->
    <el-card class="live-info-card">
      <h2 class="section-title">
        <i class="el-icon-video-play"></i> 直播时间说明
      </h2>
      <div class="live-info-content">
        <p class="live-item">📅 日常排档：每日 14:00</p>
        <p class="live-item">🎙️ 个人直播：每日 21:00</p>
        <p class="live-item">🎁 会员专属直播：每月固定1场，pia戏等特殊福利大放送</p>
        <p class="live-tips">💡 请假/时间调整会在微信群和抖音群公告</p>
      </div>
    </el-card>

    <!-- 网址跳转区域 -->
    <el-card class="homepage-content-card">
      <h2 class="section-title">
        <i class="el-icon-link"></i> 网址跳转
      </h2>

      <!-- 抖音部分 -->
      <div class="platform-section">
        <h3 class="platform-title">抖音</h3>
        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <div class="account-info">
              <span class="link-label">账号名: R.雪音</span>
              <span class="link-label">抖音号: <strong>Yukine1</strong></span>
            </div>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://v.douyin.com/wald2dQO64o/" target="_blank" class="redirect-link">
                主页直达
              </a>
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 网易云音乐部分 -->
      <div class="platform-section">
        <h3 class="platform-title">网易云相关</h3>

        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <span class="link-label">账号名: 雪音音</span>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="http://music.163.com/artist?id=30483013&userid=1343768145" target="_blank" class="redirect-link">
                主页直达
              </a>
            </el-button>
          </el-col>
        </el-row>

        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <span class="link-label">播客: 雪音の音乐世界</span>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://music.163.com/djradio?id=1005755475&uct2=U2FsdGVkX1/AYqxJ8I9YKDDurmsRb+P6kHTaMI6kzgA="
                target="_blank" class="redirect-link">
                播客直达
              </a>
            </el-button>
          </el-col>
        </el-row>

        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <span class="link-label">播客: R.雪音的pia戏日常</span>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://music.163.com/djradio?id=1005754471&uct2=U2FsdGVkX1+a3+rYWCJW4mJsjfimr8iEG2FbmkfMA/Q="
                target="_blank" class="redirect-link">
                播客直达
              </a>
            </el-button>
          </el-col>
        </el-row>

        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <span class="link-label">播客: R.雪音の睡前故事</span>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://music.163.com/djradio?id=1221390490&uct2=U2FsdGVkX19P85m0408P467cEtTVzEdgfGcWN0g1Pw8="
                target="_blank" class="redirect-link">
                播客直达
              </a>
            </el-button>
          </el-col>
        </el-row>
        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <span class="link-label">共享歌单: 与雪音の那些夜晚</span>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://music.163.com/playlist?id=17522937325&uct2=U2FsdGVkX18q2JCeA1kkEkGT3pq0rvP3FDaedc08Rpk="
                target="_blank" class="redirect-link">
                歌单直达
              </a>
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 录屏回放部分 -->
      <div class="platform-section">
        <h3 class="platform-title">录屏回放-哔哩哔哩</h3>
        <el-row class="link-row" :gutter="20">
          <el-col :span="16">
            <div class="account-info">
              <span class="link-label">账号名: 雪音的存档日记</span>
            </div>
          </el-col>
          <el-col :span="8" class="button-col">
            <el-button type="primary" size="small" class="redirect-btn">
              <a href="https://b23.tv/QUjrIyW" target="_blank" class="redirect-link">
                主页直达
              </a>
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Homepage',
  components: {
  }
}
</script>

<style scoped>
.homepage-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 标题卡片样式 */
.homepage-title-card {
  text-align: center;
  margin-bottom: 30px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.homepage-title {
  font-size: 32px;
  color: #ffad32;
  margin-bottom: 10px;
  letter-spacing: 3px;
}

.homepage-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 新增：直播信息卡片样式 */
.live-info-card {
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.live-info-content {
  padding: 15px 20px;
  font-size: 15px;
  color: #333;
  line-height: 2;
}

.live-item {
  margin: 0;
  padding: 4px 0;
  color: #555;
}

.live-tips {
  margin: 8px 0 0 0;
  color: #ffad32;
  font-size: 14px;
}

/* 内容卡片样式 */
.homepage-content-card {
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 区域标题样式 */
.section-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e4e7ed;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 8px;
  color: #ffad32;
}

/* 平台区域样式 */
.platform-section {
  margin-bottom: 25px;
}

.platform-section:last-child {
  margin-bottom: 0;
}

.platform-title {
  font-size: 16px;
  color: #666;
  margin-bottom: 15px;
  padding-left: 10px;
  border-left: 4px solid #ffad32;
}

/* 链接行样式 */
.link-row {
  margin-bottom: 12px;
  padding: 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.link-row:hover {
  background-color: #f5f7fa;
}

/* 链接标签样式 */
.link-label {
  font-size: 14px;
  color: #333;
  display: inline-block;
  line-height: 32px;
  margin-right: 20px;
}

/* 账号信息样式 */
.account-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* 按钮列样式 */
.button-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/* 按钮样式 */
.redirect-btn {
  transition: all 0.3s;
  background-color: #ffad32 !important;
  border-color: #ffad32 !important;
}

.redirect-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 173, 50, 0.3);
  background-color: #ffbd5c !important;
  border-color: #ffbd5c !important;
}

/* 重定向链接样式 */
.redirect-link {
  color: #fff;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

.redirect-link:hover {
  color: #fff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .homepage-container {
    padding: 10px;
  }

  .homepage-title {
    font-size: 24px;
  }

  .link-row {
    flex-direction: column;
  }

  .link-row .el-col {
    margin-bottom: 10px;
    width: 100%;
  }

  .button-col {
    justify-content: center;
  }
}
</style>